import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import CalendarIcon from '@mui/icons-material/CalendarToday'
import EastIcon from '@mui/icons-material/East'
import PaymentIcon from '@mui/icons-material/Payment'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  isMoveButtonVisible?: boolean
  disableAddPayment?: boolean
  disableMovePayment?: boolean
  disableCalendar?: boolean
  onAddPayment: () => void
  onMovePayment: () => void
  onGoToLoanStatus: () => void
  onGoToCalendar: () => void
}
const ActionsPayment: FC<Props> = ({
  isMoveButtonVisible,
  disableAddPayment,
  disableMovePayment,
  disableCalendar,
  onAddPayment,
  onMovePayment,
  onGoToLoanStatus,
  onGoToCalendar,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const styles = {
    actionButton: {
      backgroundColor: '#1A1A1A',
      color: 'white',
      border: 'none',
      padding: '1.5rem 1rem',
      borderRadius: '15px',
      fontSize: '12px',
      cursor: 'pointer',
      outline: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '180px',
      minWidth: '90px',
      boxSizing: 'border-box',
      marginRight: '9px',
      '&:last-child': {
        marginRight: 0,
      },
      '&:hover': {
        backgroundColor: '#333',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '1rem 1rem',
        height: '160px',
        minWidth: '80px',
        marginRight: '5px',
      },
    },
    container: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      mt: '3rem',
      padding: { xs: '0 9rem 0 0', lg: '0 2rem 0 0' },
    },
    text: {
      fontWeight: 200,
      textTransform: 'none'  
    },
  }

  return (
    <Box sx={styles.container}>
      {[
        { action: onAddPayment, icon: <PaymentIcon />, text: t('payment.titleap'),disabled: disableAddPayment },
        { action: onMovePayment, icon: <EastIcon />, text: t('payment.titlemv'), disabled: disableMovePayment, isMove: true }, 
        { action: onGoToLoanStatus, icon: <AttachMoneyIcon />, text: t('payment.loanStatus') },
        { action: onGoToCalendar, icon: <CalendarIcon />, text: t('payment.calendarTitle'),disabled: disableCalendar },
      ].filter(item => !item.disabled).map(({ action, icon, text, isMove  }) => {
        if (isMove && !isMoveButtonVisible) {
          return (
            <Tooltip title={t('payment.moveReason')} arrow key={text}>
              <Typography sx={{mr:1}}>
                <Button sx={styles.actionButton} disabled={isMove && !isMoveButtonVisible} >
                  {icon}
                  <Typography sx={styles.text}>{t('payment.titlemv')}</Typography>
                </Button>
              </Typography>
            </Tooltip>
          );
        }
        return (
          <>
          <Button key={text} sx={styles.actionButton} onClick={action} >
            {icon}
            <Typography sx={styles.text}>{text}</Typography>
          </Button>
          </>
        );
      })}
    </Box>
  );
};

export default ActionsPayment
